import React from 'react';
import './faqBanner.css';

const FAQBanner = () => {
  return (
    <div className="faq-banner-container">
      <div className="faq-curve-top"></div>
      <div className="faq-content">
        <h1 className="faq-heading">Frequently asked questions</h1>
        <div className="faq-divider"></div>
      </div>
    </div>
  );
};

export default FAQBanner;